<template>
  <div>
    <slot
      :disabledForm="['processing', 'confirmed'].includes(state)"
      :onSubmitBooking="onSubmitBooking"></slot>
    <Modal
      :show="showModal"
      :title="modalTitle"
      @hide="showModal = false"
      @hidePrevented="showModal = false"
    >
      <div v-if="state === 'processing'">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ $t('Processing booking…') }}</span>
        </div>
      </div>
      <div v-if="state === 'error'">
        <div class="alert alert-danger" role="alert">
          <p>{{ $t('An error occurred while processing your booking.') }}</p>
          <p>{{ error }}</p>
        </div>
      </div>
      <div v-else-if="state === 'confirmed'">
        <div class="alert alert-info" role="alert">
          <strong>{{ $t('Your reservation is in progress!') }}</strong><br>
          {{ $t('The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.', { minutes: lifetimeInMinutes }) }}.
        </div>
        <BookingInformation
          :booking="booking"
          class="my-2">
        </BookingInformation>
      </div>
      <template #footer  v-if="state === 'confirmed'">
        <div class="modal-footer justify-content-between flex-column">
          <RemainingTime :booking="booking" class="w-100 mb-2"></RemainingTime>
          <div class="d-flex justify-content-end w-100">
            <a class="btn btn-primary"
               :href="urlRegistration">
              {{ $t('Continue to registration') }}
            </a>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";
import Modal from "@/components/frontend/ui/Modal.vue";
import BookingInformation from "@/components/frontend/booking/BookingInformation.vue";
import RemainingTime from "@/components/frontend/booking/RemainingTime.vue";
import useBookingSession from "@/components/frontend/composable/useBookingSession.ts";
import { useI18n } from "vue-i18n";

const { setBooking } = useBookingSession();
const { t } = useI18n();

const props = defineProps({
  urlBooking: {
    type: String,
    required: true
  },
  urlRegistration: {
    type: String,
    required: true
  },
  lifetimeInMinutes: {
    type: Number,
    default: 15,
  },
});

const showModal = ref(false);
const modalTitle = ref(t("Processing booking…"));
const state  = ref('idle');
const booking = ref(null);
const error = ref(null);

const onSubmitBooking = (bookingRequest) => {
  showModal.value = true;
  state.value = 'processing';

  axios.post(props.urlBooking, bookingRequest)
    .then((response) => {
      booking.value = response.data.data
      state.value = 'confirmed'
      modalTitle.value = t("Booking information")
      setBooking(booking.value)
    })
    .catch((e) => {
      if (typeof e.response.data.message !== 'string') {
        error.value = Object.values(e.response.data.message)[0][0]
      } else {
        error.value = e.response.data.message
      }
      state.value = 'error'
    })
    .finally(() => {

    })
}
</script>